import gql from 'graphql-tag';

export default gql`
  query searchChannels(
    $keywords: String!
    $limit: Int
  ) {
    searchChannels(
      keywords: $keywords
      limit: $limit
    ) {
      id
      uri
      imageUrl
      displayName
      numberOfFollowers
    }
  }
`;
